'use client';

import { Skeleton } from '@eliadmin/core/src/components/ui/skeleton';

export const JobOfferCardSmallSkeleton = () => {
  return (
    <div className="flex h-[370px] min-w-0 items-start justify-start">
      <div className="group flex h-full w-full min-w-0 flex-col overflow-hidden rounded-2xl border border-border bg-background shadow-sm">
        <div className="flex min-h-0 w-full flex-1 flex-col">
          <div className="relative h-[160px] w-full shrink-0">
            <Skeleton className="h-full w-full" />
          </div>
          <div className="relative flex min-h-0 min-w-0 flex-1 flex-col gap-1 px-4 py-2">
            <Skeleton className="h-10 w-3/4 shrink-0" />
            <Skeleton className="h-4 w-1/2 shrink-0" />
            <Skeleton className="h-4 w-2/3 shrink-0" />
            <div className="flex h-[22px] shrink-0 gap-1 md:h-[33px]">
              <Skeleton className="h-full w-16" />
              <Skeleton className="h-full w-20" />
            </div>
          </div>
        </div>
        <div className="mt-auto flex w-full shrink-0 flex-col gap-2 p-4 pt-0">
          <Skeleton className="mt-1 h-5 w-1/2" />
          <Skeleton className="h-[15px] w-2/3" />
        </div>
      </div>
    </div>
  );
};
